var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart-area"},[_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.chartOptions(_vm.services(), 'Service Breakdown'),"autoresize":""}}),_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.chartOptions(_vm.projects(), 'Jobs Breakdown'),"autoresize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }